class LinksGridCarousel {
  constructor() {
    this.init();
  }

  init() {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(carousel => {
      this.setupCarousel(carousel);
    });
  }

  setupCarousel(carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const dots = carousel.querySelectorAll('[data-carousel-dot]');
    const items = carousel.querySelectorAll('.hdt-category-grid__carousel-item');
    
    if (!track || !dots || items.length === 0) {
      return;
    }

    // Obtener items por página desde CSS
    const colWidth = window.getComputedStyle(track).getPropertyValue('--col-width');
    const itemsPerPage = colWidth ? Math.round(100 / parseFloat(colWidth)) : 3;
    const totalPages = Math.ceil(items.length / itemsPerPage);
    
    let currentPage = 0;

    // Función para mover el carousel
    const goToPage = (pageIndex) => {
      if (pageIndex < 0 || pageIndex >= totalPages) return;
      
      currentPage = pageIndex;
      const translateX = -currentPage * 100;
      track.style.transform = `translateX(${translateX}%)`;
      
      // Actualizar dots activos
      dots.forEach((dot, i) => {
        if (i === currentPage) {
          dot.classList.add('hdt-category-grid__dot--active');
        } else {
          dot.classList.remove('hdt-category-grid__dot--active');
        }
      });
    };

    // Click en dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        goToPage(index);
      });
    });

    // Touch/Swipe
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    const handleSwipe = () => {
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          // Swipe left - siguiente
          goToPage(currentPage + 1);
        } else {
          // Swipe right - anterior
          goToPage(currentPage - 1);
        }
      }
    };

    // Mouse drag
    let mouseDown = false;
    let startX = 0;
    let scrollLeft = 0;

    track.addEventListener('mousedown', (e) => {
      mouseDown = true;
      startX = e.pageX;
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('mouseleave', () => {
      mouseDown = false;
      track.style.cursor = 'grab';
    });

    track.addEventListener('mouseup', (e) => {
      mouseDown = false;
      track.style.cursor = 'grab';
      
      const endX = e.pageX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goToPage(currentPage + 1);
        } else {
          goToPage(currentPage - 1);
        }
      }
    });

    track.addEventListener('mousemove', (e) => {
      if (!mouseDown) return;
      e.preventDefault();
    });

    // Inicializar en la primera página
    goToPage(0);
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LinksGridCarousel();
  });
} else {
  new LinksGridCarousel();
}

// Reinicializar en eventos de Shopify
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', () => {
    new LinksGridCarousel();
  });
  
  document.addEventListener('shopify:section:reorder', () => {
    new LinksGridCarousel();
  });
}

// Reinicializar al cambiar tamaño de ventana
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    new LinksGridCarousel();
  }, 250);
});
